import { FC } from "react";
import { useContent } from "contexts/contentContext/contentContext";

import "./styles.scss";

type ActionsStatusT = {
  status: string;
};

const ActionsStatus: FC<ActionsStatusT> = ({ status }) => {
  const { getTextByKey } = useContent();

  return (
    <div
      className={`action-status-wrapper ${status.toLowerCase()}-action-status`}
    >
      {getTextByKey(`${status}-action-status`)}
    </div>
  );
};

export default ActionsStatus;
